import { render, staticRenderFns } from "./sliderpc.vue?vue&type=template&id=b012742a&scoped=true"
import script from "./sliderpc.vue?vue&type=script&lang=js"
export * from "./sliderpc.vue?vue&type=script&lang=js"
import style0 from "./sliderpc.vue?vue&type=style&index=0&id=b012742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012742a",
  null
  
)

export default component.exports